import { render, staticRenderFns } from "./BreakoutRoomsEditor.vue?vue&type=template&id=e261e676&scoped=true"
import script from "./BreakoutRoomsEditor.vue?vue&type=script&lang=js"
export * from "./BreakoutRoomsEditor.vue?vue&type=script&lang=js"
import style0 from "./BreakoutRoomsEditor.vue?vue&type=style&index=0&id=e261e676&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e261e676",
  null
  
)

export default component.exports